import { render, staticRenderFns } from "./ViewItemModel.vue?vue&type=template&id=6440ea2e&scoped=true"
import script from "./ViewItemModel.vue?vue&type=script&lang=js"
export * from "./ViewItemModel.vue?vue&type=script&lang=js"
import style0 from "./ViewItemModel.vue?vue&type=style&index=0&id=6440ea2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6440ea2e",
  null
  
)

export default component.exports